import { render, staticRenderFns } from "./FoshanMobileElm39.vue?vue&type=template&id=4b8a2bfd&scoped=true"
import script from "./FoshanMobileElm39.vue?vue&type=script&lang=js"
export * from "./FoshanMobileElm39.vue?vue&type=script&lang=js"
import style0 from "./FoshanMobileElm39.vue?vue&type=style&index=0&id=4b8a2bfd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a2bfd",
  null
  
)

export default component.exports